import axios from 'axios';

const API = axios.create({ 
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://sbs-coaching-backend-production.up.railway.app' 
});

API.interceptors.request.use(config => {
  const token = localStorage.getItem('sbs_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auth
export const login = (data) => API.post('/auth/login', data);

// Courses
export const getCourses   = ()         => API.get('/courses');
export const addCourse    = (data)     => API.post('/courses', data);
export const updateCourse = (id, data) => API.put(`/courses/${id}`, data);
export const deleteCourse = (id)       => API.delete(`/courses/${id}`);

// Notes
export const getNotes           = ()       => API.get('/notes');
export const getStructuredNotes = ()       => API.get('/notes/structured');
export const uploadNote         = (fd)     => API.post('/notes', fd);
export const updateNote         = (id, fd) => API.put(`/notes/${id}`, fd);
export const deleteNote         = (id)     => API.delete(`/notes/${id}`);



// Gallery
export const getGallery    = ()       => API.get('/gallery');
export const uploadImage   = (fd)     => API.post('/gallery', fd);
export const updateGallery = (id, fd) => API.put(`/gallery/${id}`, fd);
export const deleteGallery = (id)     => API.delete(`/gallery/${id}`);

// Videos
export const getVideos   = ()         => API.get('/videos');
export const addVideo    = (data)     => API.post('/videos', data);
export const updateVideo = (id, data) => API.put(`/videos/${id}`, data);
export const deleteVideo = (id)       => API.delete(`/videos/${id}`);

// Contact
export const sendContact = (data) => API.post('/contact', data);
